import { useEffect, useRef, useState } from "react";
import { useModuleGuide } from "./use-module-guide";
import { useGuidesStore } from "@/stores/guidesStore";

const REVEAL_DELAY_MS = 4000;

export const useGuideProposal = () => {
  const { guide } = useModuleGuide();
  const { isDismissed, dismissGuide } = useGuidesStore();

  const eligible = !!guide && !isDismissed(guide.id);

  const [show, setShow] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    setShow(false);
    clearTimeout(timeoutRef.current);
    if (!eligible) return;
    timeoutRef.current = setTimeout(() => setShow(true), REVEAL_DELAY_MS);
    return () => clearTimeout(timeoutRef.current);
  }, [eligible, guide?.id]);

  const dismiss = () => {
    if (guide) dismissGuide(guide.id);
    setShow(false);
  };

  const markWatched = () => {
    if (guide) dismissGuide(guide.id);
  };

  return {
    guide: eligible ? guide : null,
    show: show && eligible,
    dismiss,
    markWatched,
  };
};
